<template id="dlgRenderShinTmpl" >
  <v-dialog v-model="dlgMapRenderImageIsOpen" fullscreen hide-overlay transition="dialog-bottom-transition" >
      <v-card>
        <v-toolbar color="primary" dark absolute left style="width: 100%">
            <v-btn icon dark v-on:click="closeMapRenderImage()"><v-icon>close</v-icon></v-btn>
            <v-toolbar-title v-if="mapDetailObj != null">
              {{mapDetailObj.map_name}}
              <v-btn 
                  class="mr-2" 
                  color="secondary" 
                  fab small bottom right absolute 
                  v-if="isEmptyObj(mapDetailObj) == false && isEmptyString(mapDetailObj.map_link) == false"
                  v-on:click="openMapLink(mapDetailObj.map_link)" >
                      <v-icon style="color:#000;" >list_alt</v-icon>
                </v-btn> 
            </v-toolbar-title>
            <v-toolbar-title v-else>{{$t('err.mapSelectedNotValid')}}</v-toolbar-title>
        </v-toolbar>
        <div v-if="isEmptyObj(mapDetailObj) == false && dlgMapRenderImageIsOpen == true">
          <div v-if="isEmptyString(mapDetailObj.map_asset) == false">
            <!-- RENDER IMAGE - START --> 
            <div id="mapImageContainer">
              <div class="mapImageMainImage"><img :src="mapDetailObj.map_asset"></div>
              
              <div v-if="poilist != null && poilist != []">
                <v-tooltip bottom v-for="item in poilist" v-bind:key="item.poi_id">
                  <template v-slot:activator="{ on, attrs }">
                    <a 
                      v-bind="attrs"
                      v-on="on"
                      href="javascript: void(0);" 
                      v-on:click="openDlgRenderImagePoi(item.poi_id)" 
                      :style="'top: ' + item.transform.position.y + '%; left: ' + item.transform.position.x + '%;'"
                      :class="item.poi_css_class"
                      >
                      <div class="mapImagePinImgBox">
                        <img :src="'/tools/renderimage/poi/' + item.background_image + '.png'">
                      </div>
                    </a>
                  </template>
                  <span>{{item.poi_name}}</span>  
                </v-tooltip>
              </div>

            </div>
            <!-- RENDER IMAGE - END --> 

            <!-- POI DETAILS -->
            <dlg-poi-details ref="dlgPoiDetails" :orgid="orgid" :siteid="siteid" :mapDetailObj="mapDetailObj"></dlg-poi-details>
          
          </div>
          
          <div v-else>
            {{ $t('err.mapAssetNotValid')}}
          </div>

      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import i18n from '@/i18n';
import {events} from '@/event-bus.js';
import constants from '@/ctConstants.js';

import ctDialogPoiDetails from "@/components/commons/ctDialogPoiDetails.vue";

export default {
    i18n,
    data: () => ({
      dlgMapRenderImageIsOpen: false,
      poilist:[]
    }),
    props: ['orgid', 'siteid', 'mapDetailObj'],
    components: {
      "dlg-poi-details":ctDialogPoiDetails,
    }, 
    methods: {
      openMapRenderImage() 
      {
        this.dlgMapRenderImageIsOpen = true;
        events.$emit(constants.EVENT_DIALOG_RENDER_3D_OPEN);
        this.poilist = [];
        this.loadPoiList();
      },
      closeMapRenderImage() 
      {
        this.dlgMapRenderImageIsOpen = false;
        events.$emit(constants.EVENT_DIALOG_RENDER_3D_CLOSE);
      },
      openMapLink(link)
      {
        window.open(link,'_blank');
      },
      loadPoiList()
      {
        if(this.isEmptyString(this.orgid))  
        {
          this.$root.setDialogMsg(i18n.t("err.orgSelectedNotValid"));
        } 
        else if(this.isEmptyString(this.siteid))  
        {
          this.$root.setDialogMsg(i18n.t("err.siteSelectedNotValid"));
        }
        else if(this.isEmptyObj(this.mapDetailObj) ||(!this.isEmptyObj(this.mapDetailObj) && this.isEmptyString(this.mapDetailObj.sitemap_id)))  
        {
          this.$root.setDialogMsg(i18n.t('err.mapSelectedNotValid'));
        }
        else 
        {
          var endpoint2go = constants.ENDPOINT_GATEWAY_RENDER_IMAGE_POI_LIST;
          endpoint2go += "?org=" + this.orgid;
          endpoint2go += "&site=" + this.siteid;
          endpoint2go += "&map=" + this.mapDetailObj.sitemap_id;
          this.$root.genericGetAuthenticatedCallEngine(endpoint2go, this.callbackLoadPoiList, 'err.loadingThreeJsPoisList');
          } 
      },
      callbackLoadPoiList(responseData)
      {
        if(!this.isEmptyObj(responseData))
        {
          this.poilist = responseData;
        }
        else 
        {
          this.$root.setDialogMsg(i18n.t("err.loadingPoi"));
        }
      },  
      openDlgRenderImagePoi(poiId)
      {
        if(this.isEmptyString(this.orgid))  
        {
          this.$root.setDialogMsg(i18n.t("err.orgSelectedNotValid"));
        } 
        else if(this.isEmptyString(this.siteid))  
        {
          this.$root.setDialogMsg(i18n.t("err.siteSelectedNotValid"));
        }
        else if(this.isEmptyObj(this.mapDetailObj) ||(!this.isEmptyObj(this.mapDetailObj) && this.isEmptyString(this.mapDetailObj.sitemap_id)))  
        {
          this.$root.setDialogMsg(i18n.t('err.mapSelectedNotValid'));
        }
        else if(this.isEmptyString(poiId))  
        {
          this.$root.setDialogMsg(i18n.t('err.poiSelectedNotValid'));
        }
        else 
        {
          // CHIAMATA AL DETTAGLIO
          var endpoint2go = constants.ENDPOINT_GATEWAY_POI_DETAILS;
          endpoint2go += "?org=" + this.orgid;
          endpoint2go += "&site=" + this.siteid;
          endpoint2go += "&map=" + this.mapDetailObj.sitemap_id;
          endpoint2go += "&poi=" + poiId;
          this.$root.genericGetAuthenticatedCallEngine(endpoint2go, this.callbackOpenDlgRenderImagePoi, 'err.loadingPoi');
        }
      }  ,
      callbackOpenDlgRenderImagePoi(responseData) 
      {
        if(!this.isEmptyObj(responseData))
        {
          this.$refs.dlgPoiDetails.openDlgPoiDetails(responseData);
        }
        else 
        {
          this.$root.setDialogMsg(i18n.t("err.loadingPoi"));
        }
      }, 
    }
};
</script>